import React, { useRef } from "react";
import { Container1, Container2, Container3, Container4, Design1, TextBox, TextBox2, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Withdraw2 = ({ t }) => {
  const ref1 = useRef();
  useScrollFadeIn(ref1);
  return (
    <Wrapper ref={ref1} className="fade-in">
      <Container1>
        <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/83394200UsingPay_7.png" alt="phoneImg" />
      </Container1>

      <Container3>
        <TextBox>
          <div>{t("withdraw-2-1")}</div>
          <div>{t("withdraw-2-2")}</div>
          <Container4>
            <TextBox2>
              <div>
                <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/592d19f3UsingPay_4.svg" alt="icon" />
              </div>
              <div>
                <span>{t("withdraw-2-3")}</span>
                <span>
                  <span>{t("withdraw-2-4")}</span>
                  <span>{t("withdraw-2-5")}</span>
                </span>
              </div>
            </TextBox2>
            <TextBox2>
              <div>
                <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/bd9fd0feUsingPay_5.svg" alt="icon" />
              </div>
              <div>
                <span>{t("withdraw-2-6")}</span>
                <span>
                  <span>{t("withdraw-2-7")}</span>
                  <span>{t("withdraw-2-8")}</span>
                </span>
              </div>
            </TextBox2>
            <TextBox2>
              <div>
                <img src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/2d03e692UsingPay_6.svg" alt="icon" />
              </div>
              <div>
                <span>{t("withdraw-2-9")}</span>
                <span>
                  <span>{t("withdraw-2-10")}</span>
                  <span>{t("withdraw-2-11")}</span>
                </span>
              </div>
            </TextBox2>
          </Container4>
        </TextBox>
      </Container3>
      <Design1></Design1>
    </Wrapper>
  );
};

export default Withdraw2;
